import IntentManageDrawer from "./intent-manage-drawer.vue";
import IIntentManageDrawer from "./intent-manage-drawer";
import { ValidationRule } from "ant-design-vue/types/form/form";
import { getModule } from "vuex-module-decorators";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import { fmtMsg } from "commonui";
import { IntentLocale } from "@/locales/localeid";
import { CLUValidations } from "@/util/constants";

export { IntentManageDrawer, IIntentManageDrawer };

export function entityNameUniqueValidator(currentEntityName?: string) {
	const conversationStore = getModule(ConversationBuilderState);
	return (rule: ValidationRule, value: string, callback: (value?: string) => void) => {
		const existingEntity = conversationStore.entities.ids.find(
			(id) => value !== currentEntityName && conversationStore.entities.directory[id].name === value
		);

		const existingCommonEntity = conversationStore.commonEntites.ids.find(
			(id) => value !== currentEntityName && conversationStore.commonEntites.directory[id].name === value
		);

		if (existingEntity || existingCommonEntity) {
			callback(fmtMsg(IntentLocale.IntentEntityNameUnique));
		} else {
			callback();
		}
	};
}

export function entityNameLengthValidator(rule: ValidationRule, value: string, callback: (value?: string) => void) {
	const isInvalid = value && value.length > CLUValidations.entityNameLengthLimit ? true : false;

	if (isInvalid) {
		callback(fmtMsg(IntentLocale.IntentNameLengthLimitMsg));
	} else {
		callback();
	}
}

export function entityNameValidator(rule: ValidationRule, value: string, callback: (value?: string) => void) {
	const isInvalid = CLUValidations.invalidEntityNameRegex.test(value);

	if (isInvalid) {
		callback(fmtMsg(IntentLocale.IntentNameInvalidCharMsg));
	} else {
		callback();
	}
}

export function manageEntityNameUniqueValidator(currentEntityId?: string) {
	const conversationStore = getModule(ConversationBuilderState);

	return (rule: ValidationRule, value: string, callback: (value?: string) => void) => {
		let transformedValue = value;

		if (transformedValue) {
			transformedValue = transformedValue.trim().toLowerCase();
		}

		const existingEntity = conversationStore.entities.ids.find(
			(id) => id !== currentEntityId && conversationStore.entities.directory[id].name.trim().toLowerCase() === transformedValue
		);

		const existingIntent = conversationStore.intents.ids.find(
			(id) => conversationStore.intents.directory[id].name.trim().toLowerCase() === transformedValue
		);

		if (existingEntity || existingIntent) {
			callback(fmtMsg(IntentLocale.IntentEntityNameUnique));
		} else {
			callback();
		}
	};
}
